<div class="actions-container">
  @for (extraAction of config.extraActions; track extraAction) {
    <button mat-button class="extra-action" [disabled]="!isActionAvailable(extraAction)" (click)="extraAction.onClick(config.grid); evaluateCloseDialog(extraAction)">
      <div class="text">{{ extraAction.title }}</div>
    </button>
  }
</div>
